var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../../common/components/base.component';
import { SpiderPage } from '../event.spider.modal.component';
var SetEventPageTagModalComponent = /** @class */ (function (_super) {
    __extends(SetEventPageTagModalComponent, _super);
    function SetEventPageTagModalComponent(fb, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.dialogRef = dialogRef;
        if (data) {
            _this.page = Object.assign({}, data);
        }
        else {
            _this.page = new SpiderPage('eventbrite', '');
        }
        return _this;
    }
    SetEventPageTagModalComponent.prototype.ngOnInit = function () {
        this.form = this.fb.group({
            url: [this.page.url, []],
            tag: [this.page.tag, []],
        });
    };
    SetEventPageTagModalComponent.prototype.save = function () {
        this.dialogRef.close({
            _id: this.page._id,
            url: this.form.value.url,
            tag: this.form.value.tag,
            socialName: this.page.socialName,
        });
    };
    SetEventPageTagModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return SetEventPageTagModalComponent;
}(BaseComponent));
export { SetEventPageTagModalComponent };
// export class SetEventPageTagModalActions {
//   confirm: (event: ButtonTriggerEvent) => void;
//   cancel?: () => void;
// }
// export class SetEventPageTagModalData {
//   page: any;
//   constructor(page?) {
//     this.page = page;
//   }
// }



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.spider/set.eventpage.tag.modal/set.eventpage.tag.modal.component.ts.pre-build-optimizer.js